import { ref } from "vue";
import { useStore } from "vuex";
import Swal from "sweetalert2";
import useUsuariosLista from "./useUsuariosLista";
import { useRouter } from "vue-router";

const useDialogCrearUsuarios = () => {
    const displayModal = ref(false);
    const router = useRouter();

    const { getUsuarios, getUsuariosInfo, usuariosinfo } = useUsuariosLista();

    const store = useStore();

    // Funcion para crear Usuario
    const crearNuevoUsuario = async (form) => {
        Swal.showLoading();

        await store.dispatch("usuarios/crearNuevoUsuario", form)
                .then(async (res) => {

                    if(res.status == 'info'){
                        let text2 = res.message;
                        if(typeof (res.message) !== 'string'){
                            text2 = '<ul>'
                            res.message.forEach(element => {
                                text2 += `<li>${element}</li>`
                            })
                            text2 += '<ul>'

                        }

                        await Swal.fire({
                            html: text2,
                            icon: "info",
                            confirmButtonText: "Aceptar",
                        })
                    }else{

                        if(res.data.status == 'info'){
                            displayModal.value = false;
                            await Swal.fire({
                                title: "Se ha producido un error al registrar el usuario",
                                text: res.data.message,
                                icon: "error",
                            })
                        }else{
                            const { data, message } = res.data;
                            displayModal.value = false;
                            await getUsuarios();
                            await Swal.fire({
                                title: "Usuario registrado exitosamente",
                                html: `
                          <p>${message}</p>
                          <p><strong>Correo:</strong> ${data["Correo: "]}</p>
                          <p><strong>Contraseña:</strong> ${data["Contraseña: "]}</p>
                        `,
                                icon: "success",
                                confirmButtonText: "Aceptar",
                            });

                        }


                    }
                })
                .catch(async (err) => {
                    console.log(err)

                });
        Swal.close();



    };

    // Funcion para crear Titular
    const crearNuevoTitular = async (form) => {
        const { data: info } = await store.dispatch("usuarios/crearNuevoTitular", form);
        const { status, message } = info;
        if (status === 'success') {
            displayModal.value = false;
            await Swal.fire("Titular registrado exitosamente", message, "success");
        } else {
            displayModal.value = false;
            await Swal.fire("Se ha producido un error al registrar el titular", message, "error");
        }
    };

    const recuperarContrasenaTitular = async (form) => {
        new Swal({
            title: "Cargando información...",
            allowOutsideClick: false,
        });

        await Swal.showLoading();
        const dataapir = await store.dispatch("usuarios/recuperarContrasenaTitular", form);


        const {  message, error, data } = dataapir;

        if (data?.status === 'success') {
            displayModal.value = false;
            await Swal.fire("Contraseña enviada al correo", message, "success");
            Swal.close();
            return true
        } else {
            console.log(error, typeof (error.message))
            if (error.status === "info") {
                if ( typeof( error.message ) == 'object') {
                    // displayModal.value = false;
                    await Swal.fire("Se ha producido un error", "Escribe un correo válido", "error");
                }
            } else {
                displayModal.value = false;
                await Swal.fire("Se ha producido un error", error.message, "error");
            }
            Swal.close();
            return false
        }
    };

    const validarTokenTitular = async (form) => {
        const { data: info } = await store.dispatch("usuarios/validarTokenTitular", form);
        // const { message } = info;
        if (info == undefined) {
            router.push('/');
            await Swal.fire("El token ha expirado", "error");
        } else {
            // console.log("Token Validado");
        }
    };

    const cambiarContrasenaTitular = async (form) => {
        const { data: info } = await store.dispatch("usuarios/cambiarContrasenaTitular", form);
        const { status, message } = info;
        if (status === 'success') {
            displayModal.value = false;
            await Swal.fire("Contraseña cambiada", message, "success");
        } else {
            displayModal.value = false;
            await Swal.fire("Se ha producido un error", message, "error");
        }
    };

    // Funcion para baja Usuario
    const bajaNuevoUsuario = async (form) => {
        const { data: info } = await store.dispatch("usuarios/bajaNuevoUsuario", form);
        const { status, message } = info;
        if (status === 'success') {
            displayModal.value = false;
            await getUsuarios();
            await Swal.fire("El usuario ha sido dado de baja", message, "success");
        } else {
            displayModal.value = false;
            await Swal.fire("Se ha producido un error al dar de baja el usuario", message, "error");
        }
    };

    // Validar curp usuario
    const validarCurpUsuario = async (form) => {
        const data = await store.dispatch("usuarios/validarCurpUsuario", form);
        return data;
    };

    //Validar datos del usuario logeado
    const usuarioNombre = ref();
    const usuarioCargo = ref();
    const usuarioOficina = ref();
    const usuarioAliasOficina = ref();
    const usuarioMiTitular = ref();

    const validarDatosUsuario = async () => {

        if ((usuariosinfo.value.nombre == "" || usuariosinfo.value.nombre == null || usuariosinfo.value.nombre == undefined) && (usuariosinfo.value.cargo == "" || usuariosinfo.value.cargo == null || usuariosinfo.value.cargo == undefined) && (usuariosinfo.value.oficina == "" || usuariosinfo.value.oficina == null || usuariosinfo.value.oficina == undefined) && (usuariosinfo.value.aliasOficina == "" || usuariosinfo.value.aliasOficina == null || usuariosinfo.value.aliasOficina == undefined) && (usuariosinfo.value.titular == "" || usuariosinfo.value.titular == null || usuariosinfo.value.titular == undefined)) {
            usuarioNombre.value = "No hay Datos";
            usuarioCargo.value = "No hay Datos";
            usuarioOficina.value = "No hay Datos";
            usuarioAliasOficina.value = "No hay Datos";
            usuarioMiTitular.value = "No hay titular";
        } else {
            usuarioNombre.value = usuariosinfo.value.nombre;
            usuarioCargo.value = usuariosinfo.value.cargo;
            usuarioOficina.value = usuariosinfo.value.oficina;
            usuarioAliasOficina.value = usuariosinfo.value.aliasOficina;
            usuarioMiTitular.value = usuariosinfo.value.titular;
        }
    }

    // Funcion para crear Usuario
    const cambiarAliasOficina = async (form, alias) => {
        await store.dispatch("usuarios/cambiarAliasOficina", form)
            .then(async(res) => {
                console.log(res)
                if (res.status === 'success') {
                    displayModal.value = false;
                    localStorage.setItem("userAlias", JSON.stringify(alias));

                    await getUsuarios();
                    await getUsuariosInfo();
                    await validarDatosUsuario();

                    await Swal.fire("Alias de oficina cambiado exitosamente", res.message, "success");
                } else {
                    displayModal.value = false;
                    console.log(res.message, res.status);
                    let text  =  '<ul>'
                    res.message.message.forEach(element => {
                        text += `<li>${element}</li>`
                    })
                    text += '</ul>'
                    await Swal.fire({
                        title: "Se ha producido un error al cambiar la oficina",
                        html: text,
                        icon: "error"
                    });
                }
            });


    };

    const editarUsuario = async (form) => {
        const { data: info } = await store.dispatch("usuarios/editarUsuario", form);
        const { status, message } = info;
        if (status === 'success') {
            displayModal.value = false;
            await getUsuarios();
            // await Swal.fire("Usuario registrado exitosamente", message, "success");
            await Swal.fire({
                title: "Usuario Modificado Exitosamente",
                icon: "success",
                confirmButtonText: "Aceptar",
              });
        }
        else {
            displayModal.value = false;
            await Swal.fire("Se ha producido un error al modificar el usuario", message, "error");
        }
    };


    return {
        crearNuevoUsuario,
        bajaNuevoUsuario,
        validarCurpUsuario,
        cambiarAliasOficina,
        validarDatosUsuario,

        usuarioNombre,
        usuarioCargo,
        usuarioOficina,
        usuarioAliasOficina,
        usuarioMiTitular,


        displayModal,

        getUsuariosInfo,
        crearNuevoTitular,
        recuperarContrasenaTitular,
        validarTokenTitular,
        cambiarContrasenaTitular,
        editarUsuario
    };
};

export default useDialogCrearUsuarios;
